import React from "react";
import { useIntl } from "react-intl";
import { object, string, number } from "yup";
import { Form, Grid, Space } from "@masterteam/mt-design-react";

import Upload from "../../../Upload";

import "./style.scss";

const { Field } = Form;
const { Row, Col } = Grid;

export const typeValidationSchema = object().shape({
  ArabicName: string().required(" "),
  EnglishName: string().required(" "),
  GracePeriod: number().required(" ").min(0, " "),
  Attachment: object().required(" ").nullable(),
});

function TypeIconTab({ readOnly, data = {}, saveData, formBag }) {
  const intl = useIntl();
  const { errors, values, setFieldValue } = formBag;

  return (
    <Space
      direction="vertical"
      size="medium"
      className="kpi-config__form__tabs__type-tab"
    >
      <Row size="medium">
        <Col span={12}>
          <Field
            name="EnglishName"
            label={intl.formatMessage({ id: "common.english-name" })}
            disabled={readOnly}
          />
        </Col>
        <Col span={12}>
          <Field
            name="ArabicName"
            label={intl.formatMessage({ id: "common.arabic-name" })}
            disabled={readOnly}
          />
        </Col>
      </Row>
      <Row size="medium">
        <Col span={12}>
          <Upload
            name="Attachment"
            label={intl.formatMessage({ id: "common.icon" })}
            error={errors.Attachment}
            onChange={(file) => setFieldValue("Attachment", file)}
            onDelete={() => setFieldValue("Attachment", null)}
            attachments={values.Attachment}
            disabled={readOnly}
            accept={{
              "image/svg+xml": [".svg"],
            }}
          />
        </Col>
      </Row>
      <Row size="medium">
        <Col span={12}>
          <Space align="center" className="control">
            <Field
              type="number"
              name="GracePeriod"
              label={intl.formatMessage({ id: "kpi-type.grace-period" })}
              disabled={readOnly}
              inputProps={{
                onKeyDown: (evt) => {
                  if (evt.key === "e" || evt.key === "-" || evt.key === "+") {
                    evt.preventDefault();
                  }
                },
                min: 0,
              }}
            />
            <div className="period-control__days">
              {intl.formatMessage({ id: "common.days" })}
            </div>
          </Space>
        </Col>
      </Row>
    </Space>
  );
}

export default TypeIconTab;
